import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Form, FormItem, FormLabel } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Img } from "components";
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'redux/hooks';
import { setRemitterName, setRemitterPAN, setRemitterDOB } from '../../../redux/features/CreateDeal';

interface RemitterDetailsSectionProps {
  servicePartner: string | number;
}

const RemitterDetailsSection: React.FC<RemitterDetailsSectionProps> = ({
  servicePartner
}) => {
  const dispatch = useDispatch();
  const { remitter_name, remitterPAN, remitterDOB } = useAppSelector((state) => state.CreateDeal);

  if (servicePartner !== 17) return null;

  return (
    <Accordion
      type="single"
      collapsible
      defaultValue="item-1"
      className="w-full relative right-10"
    >
      <AccordionItem className="border-none" value="item-1">
        <AccordionTrigger className="bg-[#F9F9F9] rounded-xl border-none px-5">
          <div className="flex justify-between">
            <div className="flex gap-2 items-center">
              <div>
                <Img src="/images/remit/beni.svg" alt="" />
              </div>
              <div>Remitter Details</div>
            </div>
          </div>
        </AccordionTrigger>
        <AccordionContent className="flex flex-col mt-5 pl-10 gap-10 w-2/3">
          <div className="flex flex-col gap-5">
            <FormItem className="space-y-0 relative w-full flex flex-col gap-3">
              <div className="flex items-center top-0 flex-col after:right-10 after:h-24 after:border-blue-700 absolute after:relative after:content-[''] after:border after:border-dashed">
                <img
                  className="relative -left-10"
                  src="images/overview/ellipse.svg"
                  alt=""
                />
              </div>
              <FormLabel className="text-black-label text-sm font-medium leading-[17px]">
                What is the name of remitter
              </FormLabel>
              <Input
                value={remitter_name}
                onChange={(e) => dispatch(setRemitterName(e.target.value))}
                name="remitter_name"
                placeholder="Enter Remitter Name"
                className="m-0 h-12 max-w-[340px] border border-gray-border-gray-lite p-4 rounded-lg py-2 px-3"
              />
            </FormItem>

            <FormItem className="space-y-0 relative w-full flex flex-col gap-3">
              <div className="flex items-center top-0 flex-col after:right-10 after:h-24 after:border-blue-700 absolute after:relative after:content-[''] after:border after:border-dashed">
                <img
                  className="relative -left-10"
                  src="images/overview/ellipse.svg"
                  alt=""
                />
              </div>
              <FormLabel className="text-black-label text-sm font-medium leading-[17px]">
                What is the PAN of remitter
              </FormLabel>
              <Input
                value={remitterPAN}
                onChange={(e) => dispatch(setRemitterPAN(e.target.value))}
                name="pan"
                placeholder="Enter Remitter PAN"
                className="m-0 h-12 max-w-[340px] border border-gray-border-gray-lite p-4 rounded-lg py-2 px-3"
              />
            </FormItem>

            <FormItem className="space-y-0 relative w-full flex flex-col gap-3">
              <div className="flex items-center top-0 flex-col after:right-10 after:h-0 absolute after:relative after:content-[''] after:border after:border-dashed">
                <img
                  className="relative -left-10"
                  src="images/overview/ellipse.svg"
                  alt=""
                />
              </div>
              <FormLabel className="text-black-label text-sm font-medium leading-[17px]">
                What is the DOB of remitter
              </FormLabel>
              <Input
                value={remitterDOB}
                onChange={(e) => dispatch(setRemitterDOB(e.target.value))}
                type="date"
                name="dob"
                max={new Date().toISOString().split("T")[0]}
                placeholder="Enter Remitter DOB"
                className="m-0 h-12 max-w-[340px] border border-gray-border-gray-lite p-4 rounded-lg py-2 px-3"
              />
            </FormItem>
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default RemitterDetailsSection;